export const useScript = (scriptUrl) => {
  if (!scriptUrl) return;

  const script = document.createElement("script");

  script.src = scriptUrl;
  script.async = true;

  document.body.appendChild(script);
}


// WEBPACK FOOTER //
// ./src/helpers/dom_util.js